import * as models from '@app/models/index';
import { connect } from 'react-redux';
import ResetPasswordComponent from './reset-password.component';
function mapStateToProps({}: any): any {
	return {};
}
function mapDispatchToProps(): models.IResetPasswordProps {
	return {
		intl: null,
		openSnackBar: null,
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordComponent);



// WEBPACK FOOTER //
// ./src/components/account/reset-password/reset-password.ts